export class NestedData {

	// Properties
	data: any;
	identifier: string;
	parent: NestedData;
	children: NestedData[] = [];
	showChildren = false;
	selected = false;
	header = false;
	ID: number | string;
	style: any = {};
	allowTab = false;
	ariaLabel: string;
	click = (event: MouseEvent, nestedData: NestedData) => {};
	keydown = (event: KeyboardEvent, nestedData: NestedData) => {};

	// Class Function
	constructor(data: any, parent: NestedData, ID: number | string, identifier?: string, children?: NestedData[]) {
		this.data = data;
		this.identifier = identifier;
		this.parent = parent;
		if (children) {
			this.children = children;
		}
	}

	get level(): number {
		let level = 0;
		let datum: NestedData = this;
		while (datum.parent) {
			level += 1;
			datum = datum.parent;
		}
		return level;
	}

	get shown(): boolean {
		let datum: NestedData = this;
		while (datum.parent) {
			if (datum.parent.showChildren == false) {
				return false;
			}
			datum = datum.parent;
		}
		return true;
	}

	get hasChildren(): boolean {
		return this.children && this.children.length > 0;
	}

	get showingChildren(): boolean {
		return this.hasChildren && this.showChildren;
	}

	get lastChild(): boolean {
		if (this.parent) {
			const index = this.parent.children.indexOf(this);
			if (index + 1 == this.parent.children.length) {
				return true;
			}
		}
		return false;
	}

	// Methods
	parentSelected(levelsAbove = 1) {
		let datum: NestedData = this;
		while (levelsAbove > 0 && datum) {
			datum = datum.parent;
			levelsAbove -= 1;
		}
		return datum && datum.selected;
	}

	parentShowChildren(levelsAbove = 1) {
		let datum: NestedData = this;
		while (levelsAbove > 0 && datum) {
			datum = datum.parent;
			levelsAbove -= 1;
		}
		return datum && datum.showChildren;
	}
}
